import React from "react";
import "./prijava.css";

const Prijava = () => {
  return (
    <div className="prijava-wrapper">

      {/* BACKGROUND EFFECTS */}
      <div className="bg-effects">

        <div className="glow glow1"></div>
        <div className="glow glow2"></div>
        <div className="glow glow3"></div>

        {[...Array(25)].map((_, i) => (
          <span
            key={i}
            className="spark"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${6 + Math.random() * 10}s`,
            }}
          ></span>
        ))}

      </div>

      {/* HERO */}
      <section className="prijava-hero">

        <div className="prijava-overlay"></div>

        <div className="prijava-content">

          <p className="prijava-subtitle">
            GHOST ATTACK 2.0
          </p>

          <h1>
            PRIJAVA <span>VOZILA</span>
          </h1>

          <p className="prijava-desc">
            Želiš biti dio eventa i predstaviti svoj build?
            Pošalji prijavu i osiguraj svoje mjesto među
            najboljim projektima auto scene.
          </p>

        </div>

      </section>

      {/* STEPS */}
      <section className="steps-section">

       <div className="step-card">

            <div className="step-number">01</div>

            <h2>Pripremi informacije</h2>

            <p className="step-intro">
                U prijavi pošalji:
            </p>

           <ul className="step-list">
                <li>👤 Ime i prezime</li>
                <li>📍 Mjesto iz kojeg dolaziš</li>
                <li>🏁 Klub (ako si član)</li>
                <li>🚗 Model auta</li>
                <li>🔢 Registarska oznaka</li>
                <li>📸 Slike (minimalno 3)</li>
                <li>📱 Instagram username</li>
            </ul>

            </div>

        <div className="step-card">

                <div className="step-number">02</div>

                <h2>Pošalji prijavu</h2>

                <p>
                    Sve informacije pošalji na službeni mail:
                </p>

                <div className="mail-center">

                    <a
                    href="mailto:prijave@ghost-crew.eu"
                    className="mail-btn"
                    >
                    ✉ prijave@ghost-crew.eu
                    </a>

                </div>

                </div>

        <div className="step-card">

            <div className="step-number">03</div>

            <h2>Potvrda sudjelovanja</h2>

            <p>
                Nakon pregleda prijave dobit ćeš potvrdu,
                dodatne informacije i detalje vezane uz event.
                Također tvoj auto bit će objavljen na našem profilu!
            </p>

            <div className="ig-promo">

                <a
                href="https://www.instagram.com/ghost.crew.hr/"
                target="_blank"
                rel="noreferrer"
                className="ig-btn"
                >
                <i className="fab fa-instagram"></i>
                Pogledaj naš Instagram!
                </a>

            </div>

</div>

      </section>

      {/* INFO */}
      <section className="extra-info">

        <div className="info-box">
          <h2>🏁 Tko se može prijaviti?</h2>

          <p>
            Svi ljubitelji auto scene —
            stance, OEM+, track buildovi,
            oldtimeri, tuning projekti i showcars.
          </p>
        </div>

        <div className="info-box">
          <h2>📸 Media & Influenceri</h2>

          <p>
            Fotografima i influencerima osigurane su
            posebne media zone i pristup premium lokacijama.
          </p>
        </div>

      </section>

    </div>
  );
};

export default Prijava;